const mutations = {
  SET_LOADING(state, key) {
    state.loading[key] = true
  },
  CLEAR_LOADING(state, key) {
    state.loading[key] = false
  },
  SET_AGENCY_LIST(state, payload) {
    state.agencyList = payload
  },
  SET_AGENCY_SEARCH_RESULT(state, payload) {
    state.agencySearchResult = payload
  },
}

export default mutations
